import SegmentedBar from 'components/SegmentedBar';
import React from 'react';

/**
 * Props for the ComplianceBar component.
 */
type ComplianceBarProps = {
  /** Number of passed items. */
  passedCount: number;

  /** Number of failed items. */
  failedCount: number;

  /** Optional height of the bar. */
  height?: string;

  /** Optional width of the bar. */
  width?: string;
};

/**
 * ComplianceBar component displays a segmented bar representing the percentage
 * of passed and failed items, with a tooltip showing detailed information.
 *
 * @param {ComplianceBarProps} props - The props for the component.
 * @returns {JSX.Element} The rendered ComplianceBar component.
 */
const ComplianceBar: React.FC<ComplianceBarProps> = ({
  passedCount,
  failedCount,
  height = '6px',
  width = '140px',
}) => {
  const total = passedCount + failedCount;

  const tooltip =
    total === 0
      ? 'No results available'
      : `Failed: ${failedCount}, Passed: ${passedCount}`;

  return (
    <SegmentedBar
      height={height}
      width={width}
      segments={[
        {
          color: 'danger',
          value: failedCount,
          label: 'Fail',
        },
        {
          color: 'success',
          value: passedCount,
          label: 'Pass',
        },
      ]}
      labelDisplay="percentage"
      tooltip={tooltip}
    />
  );
};

export default ComplianceBar;
